import GamecenterEditedContestModal from '../../../../common/components/GamecenterEditedContestModal/GamecenterEditedContestModal';
import GamecenterEntriesPageScheduled from '../../../../common/components/GamecenterEntriesPageScheduled/GamecenterEntriesPageScheduled';
import { EntryNameEditModalContextProvider } from '../../../../common/context/EntryNameEditModalContext/EntryNameEditModalContext';
import ConfirmationModalContextProvider from '../../../../common/context/GamecenterConfirmationModalContext/ConfirmationModalContextProvider';
import EntryScheduledMultiSlate from '../../../../player/EntryScheduledMultiSlate/EntryScheduledMultiSlate';
import usePlayerSurvivorEntriesScheduled from '../../../hooks/usePlayerSurvivorEntriesScheduled';
import GamecenterModalsContextProvider from '../../../../common/context/GamecenterModalsContext/GamecenterModalsContextProvider';

function PlayerSurviorEntriesPageScheduled() {
  const { isLoading, error, entries, hasNextPage, isFetchingNextPage, fetchNextPage } =
    usePlayerSurvivorEntriesScheduled();

  return (
    <GamecenterModalsContextProvider>
      <ConfirmationModalContextProvider>
        <EntryNameEditModalContextProvider>
          <GamecenterEditedContestModal />
          <GamecenterEntriesPageScheduled
            isLoading={isLoading}
            error={error}
            entries={entries}
            hasNextPage={hasNextPage}
            isFetchingNextPage={isFetchingNextPage}
            fetchNextPage={fetchNextPage}
            EntryComponent={EntryScheduledMultiSlate}
          />
        </EntryNameEditModalContextProvider>
      </ConfirmationModalContextProvider>
    </GamecenterModalsContextProvider>
  );
}

export default PlayerSurviorEntriesPageScheduled;
